define("checkout/components/seamless-checkout-table", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component"], function (_exports, _component, _templateFactory, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <table class="o--table o--table--condensed tPF--checkout__table">
    <tbody>
      {{!-- invoice --}}
      <tr class="tPF--checkout__tr--border">
        <td><span class="u--text--bold">{{t "plans.checkout.plan.line_item_plan" name=@selectedSubscriptionPlan.name}}</span></td>
        <td></td>
        <td><span class="u--float--right">{{format-currency @selectedSubscriptionPlan.amount}}</span></td>
      </tr>
      <tr>
        <td class="u--p__b__0"><span>{{t "shared_phrases.social_sets.info.header"}}</span></td>
        {{#if @canAddons}}
          <td class="u--p__b__0">
            <InputStepper
              @currentValue={{add @selectedSubscriptionPlan.numberOfSocialSets @additionalSocialSetCount}}
              @onStepDown={{fn @onSocialSetChange -1}}
              @onStepUp={{fn @onSocialSetChange 1}}
              @minValue={{@selectedSubscriptionPlan.numberOfSocialSets}}
              @tooltipAtMin={{t "plans.checkout.addons.tooltip_at_minimum" planName=@selectedSubscriptionPlan.name numSocialSets=@selectedSubscriptionPlan.numberOfSocialSets numUsers=@selectedSubscriptionPlan.numberOfUsers}}
            />
          </td>
          <td class="u--p__b__0">
            <span class="u--text--bold u--float--right"> {{format-currency @totalSocialSetCost}} </span>
          </td>
        {{else}}
          <td class="u--p__b__0">
            <span
              class="o--btn o--btn--outline u--text--light qa--input_counter"
              data-test-id="change"
            >
              {{@selectedSubscriptionPlan.numberOfSocialSets}}
              <EmberTooltip
                @delay={{330}}
                @side="top"
              >
                {{t "plans.checkout.addons.tooltip_feature_unavailable"}}
              </EmberTooltip>
            </span>
          </td>
          <td class="u--p__b__0"></td>
        {{/if}}
      </tr>
      <tr>
        <td><span>{{t "shared_words.users"}}</span></td>
        {{#if @canAddons}}
          <td>
            <InputStepper
              @onStepDown={{fn @onTeamMemberChange -1}}
              @onStepUp={{fn @onTeamMemberChange 1}}
              @currentValue={{add @selectedSubscriptionPlan.numberOfUsers @additionalTeamMemberCount}}
              @minValue={{@selectedSubscriptionPlan.numberOfUsers}}
              @tooltipAtMin={{t "plans.checkout.addons.tooltip_at_minimum" planName=@selectedSubscriptionPlan.name numSocialSets=@selectedSubscriptionPlan.numberOfSocialSets numUsers=@selectedSubscriptionPlan.numberOfUsers}}
            />
          </td>
          <td>
            <span class="u--text--bold u--float--right"> {{format-currency @totalTeamMemberCost}} </span>
          </td>
        {{else}}
          <td>
            <span
              class="o--btn o--btn--outline u--text--light qa--input_counter"
              data-test-id="change"
            >
              {{@selectedSubscriptionPlan.numberOfSocialSets}}
              <EmberTooltip
                @delay={{330}}
                @side="top"
              >
                {{t "plans.checkout.addons.tooltip_feature_unavailable"}}
              </EmberTooltip>
            </span>
          </td>
          <td></td>
        {{/if}}
      </tr>
      {{!-- coupon deduction --}}
      {{#if @coupon}}
        <tr class="u--text">
          <td>
            <span class="u--text--bold">
              {{t "plans.checkout.plan.line_item_coupon" description=this.couponDescription}}
            </span>
          </td>
          <td></td>
          <td>
            <span>
              {{concat "-" (format-currency @discount)}}
            </span>
          </td>
        </tr>
      {{/if}}
      {{!-- subtotal --}}
      <tr class="tPF--checkout__tr--border u--text u--text--bold">
        <td class="u--p__b__0" colspan="2">
          <span>
            {{#if @isMonthly }}
              {{t
                "plans.checkout.plan.line_item_monthly_total_on_date_trial"
                date=(moment-format @proration.futureDate "MMM DD, YYYY")
              }}
            {{else}}
              {{t
                "plans.checkout.plan.line_item_yearly_total_on_date_trial"
                date=(moment-format @proration.futureDate "MMM DD, YYYY")
              }}
            {{/if}}
          </span>
          <p class="u--text--light u--text--sm u--text--base u--p__t__xs">
            {{#if (or checkout.isEligibleForTrial checkout.hasActiveTrial)}}
              <span>{{t "plans.checkout.plan.trial_disclaimer_short"}}</span>
            {{/if}}
            <span>
              {{t
                "plans.checkout.plan.trial_disclaimer_details"
                interval=@selectedSubscriptionPlan.intervalName
                amount=(format-currency @proration.futureAmount)
                date=(moment-format @proration.futureDate "MMM DD, YYYY")
              }}
            </span>
          </p>
        </td>
        <td class="u--p__b__0">
          <span class="u--float--right qa--checkout__summary--totalText qa--total_value">
            {{format-currency @proration.futureAmount}}
          </span>
        </td>
      </tr>
    </tbody>
  </table>
  
  
  */
  {
    "id": "rc3oKxKJ",
    "block": "[[[10,\"table\"],[14,0,\"o--table o--table--condensed tPF--checkout__table\"],[12],[1,\"\\n  \"],[10,\"tbody\"],[12],[1,\"\\n\"],[1,\"    \"],[10,\"tr\"],[14,0,\"tPF--checkout__tr--border\"],[12],[1,\"\\n      \"],[10,\"td\"],[12],[10,1],[14,0,\"u--text--bold\"],[12],[1,[28,[35,0],[\"plans.checkout.plan.line_item_plan\"],[[\"name\"],[[30,1,[\"name\"]]]]]],[13],[13],[1,\"\\n      \"],[10,\"td\"],[12],[13],[1,\"\\n      \"],[10,\"td\"],[12],[10,1],[14,0,\"u--float--right\"],[12],[1,[28,[35,1],[[30,1,[\"amount\"]]],null]],[13],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,\"tr\"],[12],[1,\"\\n      \"],[10,\"td\"],[14,0,\"u--p__b__0\"],[12],[10,1],[12],[1,[28,[35,0],[\"shared_phrases.social_sets.info.header\"],null]],[13],[13],[1,\"\\n\"],[41,[30,2],[[[1,\"        \"],[10,\"td\"],[14,0,\"u--p__b__0\"],[12],[1,\"\\n          \"],[8,[39,3],null,[[\"@currentValue\",\"@onStepDown\",\"@onStepUp\",\"@minValue\",\"@tooltipAtMin\"],[[28,[37,4],[[30,1,[\"numberOfSocialSets\"]],[30,3]],null],[28,[37,5],[[30,4],-1],null],[28,[37,5],[[30,4],1],null],[30,1,[\"numberOfSocialSets\"]],[28,[37,0],[\"plans.checkout.addons.tooltip_at_minimum\"],[[\"planName\",\"numSocialSets\",\"numUsers\"],[[30,1,[\"name\"]],[30,1,[\"numberOfSocialSets\"]],[30,1,[\"numberOfUsers\"]]]]]]],null],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"td\"],[14,0,\"u--p__b__0\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"u--text--bold u--float--right\"],[12],[1,\" \"],[1,[28,[35,1],[[30,5]],null]],[1,\" \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,\"td\"],[14,0,\"u--p__b__0\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"o--btn o--btn--outline u--text--light qa--input_counter\"],[14,\"data-test-id\",\"change\"],[12],[1,\"\\n            \"],[1,[30,1,[\"numberOfSocialSets\"]]],[1,\"\\n            \"],[8,[39,6],null,[[\"@delay\",\"@side\"],[330,\"top\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,0],[\"plans.checkout.addons.tooltip_feature_unavailable\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"td\"],[14,0,\"u--p__b__0\"],[12],[13],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n    \"],[10,\"tr\"],[12],[1,\"\\n      \"],[10,\"td\"],[12],[10,1],[12],[1,[28,[35,0],[\"shared_words.users\"],null]],[13],[13],[1,\"\\n\"],[41,[30,2],[[[1,\"        \"],[10,\"td\"],[12],[1,\"\\n          \"],[8,[39,3],null,[[\"@onStepDown\",\"@onStepUp\",\"@currentValue\",\"@minValue\",\"@tooltipAtMin\"],[[28,[37,5],[[30,6],-1],null],[28,[37,5],[[30,6],1],null],[28,[37,4],[[30,1,[\"numberOfUsers\"]],[30,7]],null],[30,1,[\"numberOfUsers\"]],[28,[37,0],[\"plans.checkout.addons.tooltip_at_minimum\"],[[\"planName\",\"numSocialSets\",\"numUsers\"],[[30,1,[\"name\"]],[30,1,[\"numberOfSocialSets\"]],[30,1,[\"numberOfUsers\"]]]]]]],null],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"td\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"u--text--bold u--float--right\"],[12],[1,\" \"],[1,[28,[35,1],[[30,8]],null]],[1,\" \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,\"td\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"o--btn o--btn--outline u--text--light qa--input_counter\"],[14,\"data-test-id\",\"change\"],[12],[1,\"\\n            \"],[1,[30,1,[\"numberOfSocialSets\"]]],[1,\"\\n            \"],[8,[39,6],null,[[\"@delay\",\"@side\"],[330,\"top\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,0],[\"plans.checkout.addons.tooltip_feature_unavailable\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"td\"],[12],[13],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n\"],[41,[30,9],[[[1,\"      \"],[10,\"tr\"],[14,0,\"u--text\"],[12],[1,\"\\n        \"],[10,\"td\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"u--text--bold\"],[12],[1,\"\\n            \"],[1,[28,[35,0],[\"plans.checkout.plan.line_item_coupon\"],[[\"description\"],[[30,0,[\"couponDescription\"]]]]]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"td\"],[12],[13],[1,\"\\n        \"],[10,\"td\"],[12],[1,\"\\n          \"],[10,1],[12],[1,\"\\n            \"],[1,[28,[35,7],[\"-\",[28,[37,1],[[30,10]],null]],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[10,\"tr\"],[14,0,\"tPF--checkout__tr--border u--text u--text--bold\"],[12],[1,\"\\n      \"],[10,\"td\"],[14,0,\"u--p__b__0\"],[14,\"colspan\",\"2\"],[12],[1,\"\\n        \"],[10,1],[12],[1,\"\\n\"],[41,[30,11],[[[1,\"            \"],[1,[28,[35,0],[\"plans.checkout.plan.line_item_monthly_total_on_date_trial\"],[[\"date\"],[[28,[37,8],[[30,12,[\"futureDate\"]],\"MMM DD, YYYY\"],null]]]]],[1,\"\\n\"]],[]],[[[1,\"            \"],[1,[28,[35,0],[\"plans.checkout.plan.line_item_yearly_total_on_date_trial\"],[[\"date\"],[[28,[37,8],[[30,12,[\"futureDate\"]],\"MMM DD, YYYY\"],null]]]]],[1,\"\\n\"]],[]]],[1,\"        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--text--light u--text--sm u--text--base u--p__t__xs\"],[12],[1,\"\\n\"],[41,[28,[37,9],[[33,10,[\"isEligibleForTrial\"]],[33,10,[\"hasActiveTrial\"]]],null],[[[1,\"            \"],[10,1],[12],[1,[28,[35,0],[\"plans.checkout.plan.trial_disclaimer_short\"],null]],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[10,1],[12],[1,\"\\n            \"],[1,[28,[35,0],[\"plans.checkout.plan.trial_disclaimer_details\"],[[\"interval\",\"amount\",\"date\"],[[30,1,[\"intervalName\"]],[28,[37,1],[[30,12,[\"futureAmount\"]]],null],[28,[37,8],[[30,12,[\"futureDate\"]],\"MMM DD, YYYY\"],null]]]]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"td\"],[14,0,\"u--p__b__0\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"u--float--right qa--checkout__summary--totalText qa--total_value\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[[30,12,[\"futureAmount\"]]],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"]],[\"@selectedSubscriptionPlan\",\"@canAddons\",\"@additionalSocialSetCount\",\"@onSocialSetChange\",\"@totalSocialSetCost\",\"@onTeamMemberChange\",\"@additionalTeamMemberCount\",\"@totalTeamMemberCost\",\"@coupon\",\"@discount\",\"@isMonthly\",\"@proration\"],false,[\"t\",\"format-currency\",\"if\",\"input-stepper\",\"add\",\"fn\",\"ember-tooltip\",\"concat\",\"moment-format\",\"or\",\"checkout\"]]",
    "moduleName": "checkout/components/seamless-checkout-table.hbs",
    "isStrictMode": false
  });

  class SeamlessCheckoutTable extends _component2.default {
    get couponDescription() {
      if (!this.args.coupon) {
        return null;
      }

      const name = this.args.coupon.name || this.args.coupon.id;
      return this.args.coupon.percentOff ? "".concat(name, " ").concat(this.args.coupon.percentOff, "%") : "".concat(name);
    }

  }

  _exports.default = SeamlessCheckoutTable;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SeamlessCheckoutTable);
});